<script>
  import * as bigintConversion from "bigint-conversion";
  import { onMount, afterUpdate } from "svelte";
  // import { crc8, packCrc8, checkPackedCrc8 } from './crc'
  // import { encode, decode } from "./crc8";
  import { fromCodeToACCN, ABC } from "./accn.js";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let mask = "   -   -   -   ";
  let p = 0;
  export let intval = "";
  let intarr = [];
  let input;
  let valid = false;
  let crcerror = false;

  onMount(() => {
    intarr = [...mask];
    intval = mask;
  });

  function keyUp(event) {
    // console.log('up', event);
    const key = event.key;

    if (key === "Control" || event.ctrlKey || event.metaKey) {
      return false;
    }

    addChar(key);
  }

  function handlePaste(event) {
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    //console.log("paste", paste);
    for (const key of paste) addChar(key);
  }

  function addChar(key) {
    //console.log('key:', key,'beg p: '+p+' intv: '+intval+' inarr: '+intarr.join(''))
    if (key == "Backspace" || key == "ArrowLeft") {
      if (p == 0) return;
      if (p > 0 && intarr[p - 1] == "-") --p;
      intarr[--p] = " ";
      if (intarr[p] == "-") --p;
    } else if (key.length == 1 && ABC.includes(key.toUpperCase())) {
      if (p == mask.length) return;
      intarr[p] = key.toUpperCase();
      ++p;
      if (intarr[p] == "-") ++p;
    }

    intval = intarr.join("");
    validate();
    //console.log('end p: '+p+' intv: '+intval+' inarr: '+intarr.join(''))
  }

  function keyDown(event) {
    // console.log('down', event);

    if (event.ctrlKey || event.metaKey) {
      return false;
    }
    event.preventDefault();
  }

  function validate() {
    /* let res = ''
        let chk
        if(p == mask.length) {
            for(let i = 0; i<mask.length; ++i)
                if(mask[i] == ' ') res += intval[i]
            const i = BigInt(res)
            const arr = bigintConversion.bigintToBuf(i);
            chk = checkPackedCrc8(arr)
            crcerror = !chk.res
            if (!crcerror)
                valid = true
        }
        else {
            valid = false
            crcerror = false
        } */
    let val, _;
    if (p === mask.length) {
      try {
        const res = fromCodeToACCN(intval.split("-"));
        //console.log(intval, res);
        val = res.fileName.toString();
        valid = res.crcOK;
      } catch (err) {
        valid = false;
        crcerror = true;
        console.log(err);
      }
    } else {
      valid = false;
      crcerror = false;
    }
    // dispatch('valid', {valid: valid, value: chk ? chk.orig : ''})
    //console.log(valid, val);
    dispatch("valid", { valid: valid, value: valid ? val : "" });
  }

  function click() {
    intarr = [...mask];
    intval = mask;
    p = 0;
    input.setSelectionRange(p, p);
    valid = false;
    crcerror = false;
    dispatch("cleared", {});
    dispatch("valid", { valid: false, value: "" });
  }

  afterUpdate(() => {
    input.setSelectionRange(p, p);
  });
</script>

<main>
  <input
    type="text"
    size={mask.length}
    class:valid
    class:invalid={!valid}
    bind:this={input}
    on:paste|preventDefault={handlePaste}
    on:keyup|preventDefault={keyUp}
    on:click|preventDefault={click}
    on:keypress|preventDefault={() => {}}
    on:keydown={keyDown}
    value={intval}
    tabindex="0"
  />
  {#if crcerror}
    <span style="color: red">Hibás kód! Kérjük adja meg a kódot újra.</span>
  {/if}
</main>

<style>
  input {
    font-family: "Courier New", Courier, monospace;
    font-size: large;
    outline: none;
    border-radius: 2px;
  }
  .valid {
    border: 2px solid green !important;
  }
  .invalid {
    border: 2px solid red !important;
  }
</style>
